<div class="flex h-screen w-full overflow-hidden">
    @if(gs.users.role != 'Evaluator'){
    <app-sidebar class="z-20 shadow-xl"></app-sidebar>
    }
    <div class="scrollbar-thin relative p-4 bg-surface-100 bg-[#f7f7f7] w-full h-[99vh] md:h-[100vh] overflow-y-auto">
        <!-- <app-header label="Project"></app-header> -->
        <router-outlet></router-outlet>
    </div>
</div>